// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CreatePassword_wrapper__4B24j","logo":"CreatePassword_logo__XNP75","reset-button":"CreatePassword_reset-button__fl1UT"};